import React, { useState, useEffect } from "react";
import ModalImage from "react-modal-image";
import "./Fix.css";

const imgStyle = {
    transition: "transform .135s cubic-bezier(0.0,0.0,0.2,1),opacity linear .15s"
};
const selectedImgStyle = {
    transform: "translateZ(0px) scale3d(0.9, 0.9, 1)",
    transition: "transform .135s cubic-bezier(0.0,0.0,0.2,1),opacity linear .15s"
};
const cont = {
    backgroundColor: "#eee",
    cursor: "pointer",
    overflow: "hidden",
    position: "relative",
    background: "transparent"
};

const SelectedImage = ({
    src,
    margin,
    index,
    photo,
    left,
    top
}) => {
  //calculate x,y scale
    const sx = (100 - (30 / photo.width) * 100) / 100;
    const sy = (100 - (30 / photo.height) * 100) / 100;
    selectedImgStyle.transform = `translateZ(0px) scale3d(${sx}, ${sy}, 1)`;
    cont.position = "absolute";
    cont.left = left;
    cont.top = top;

    const handleOnClick = e => {
        
    };

    return (
        <div
        style={{ margin, height: photo.height, width: photo.width, ...cont }}
        className="not-selected">
            <ModalImage alt={photo.title} style={imgStyle} small={src} medium={src} style={{left: left, top: top}} hideDownload onClick={handleOnClick}/>
        </div>
    );
};

export default SelectedImage;
